module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/004-7e1883b649123af9ee6f1557cacfb221.jpg";